export default __webpack_public_path__ + "static/media/translate.ccb68f85.svg";